import { Col, Row } from 'react-bootstrap';
import DatePicker from 'portaltransparencia-common/components/DatePicker.react.js';
import Input from 'portaltransparencia-common/components/EloInput.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import React from 'react';
import FilterButtons from '../../components/FilterButtons.react';
import {
  DEFAULT_SITUACOES,
  SITUACAO_INTERVENCAO_OXY,
  corPorSituacao
} from './situacaoIntervencaoOxy';

const INITIAL_FILTROS = {
  descricaoObra: '',
  descricaoBem: '',
  empresa: '',
  anoIntervencao: '',
  numeroIntervencao: '',
  situacoes: DEFAULT_SITUACOES,
  dataParalisacaoInicio: '',
  dataParalisacaoFim: '',
  dataReinicioInicio: '',
  dataReinicioFim: ''
};

export { INITIAL_FILTROS };

const MapaObrasPublicasFilters = ({
  filtros,
  onChange,
  onConsulta,
  onReset
}) => {
  const handleChange = e => {
    const { name, value } = e.target;
    onChange({ ...filtros, [name]: value });
  };

  const handleSituacaoChange = situacao => {
    const situacoes = filtros.situacoes || [];
    const novasSituacoes = situacoes.includes(situacao)
      ? situacoes.filter(s => s !== situacao)
      : [...situacoes, situacao];
    onChange({ ...filtros, situacoes: novasSituacoes });
  };

  const handleDateChange = e => {
    const { name, value } = e.target;
    onChange({ ...filtros, [name]: value });
  };

  return (
    <Panel title="Mapa de Obras Públicas" mobileClose>
      <form
        onSubmit={e => {
          e.preventDefault();
          onConsulta();
        }}
      >
        <Row>
          <Col xs={12} sm={6} md={3}>
            <Input
              name="descricaoBem"
              label="Descrição do Bem"
              type="text"
              onChange={handleChange}
              value={filtros.descricaoBem}
            />
          </Col>
          <Col xs={12} sm={6} md={3}>
            <Input
              name="descricaoObra"
              label="Descrição da Intervenção"
              type="text"
              onChange={handleChange}
              value={filtros.descricaoObra}
            />
          </Col>
          <Col xs={12} sm={6} md={3}>
            <Input
              name="empresa"
              label="Empresa"
              type="text"
              onChange={handleChange}
              value={filtros.empresa}
            />
          </Col>
          <Col xs={12} sm={6} md={2}>
            <Input
              name="anoIntervencao"
              label="Ano de Intervenção"
              type="number"
              onChange={handleChange}
              value={filtros.anoIntervencao}
            />
          </Col>
          <Col xs={12} sm={6} md={2}>
            <Input
              name="numeroIntervencao"
              label="Nº da Intervenção"
              type="number"
              onChange={handleChange}
              value={filtros.numeroIntervencao}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={6} md={2}>
            <DatePicker
              id="dataParalisacaoInicio"
              name="dataParalisacaoInicio"
              label="Data Paralisação Mínima"
              onChange={handleDateChange}
              value={filtros.dataParalisacaoInicio}
            />
          </Col>
          <Col xs={12} sm={6} md={2}>
            <DatePicker
              id="dataParalisacaoFim"
              name="dataParalisacaoFim"
              label="Data Paralisação Máxima"
              onChange={handleDateChange}
              value={filtros.dataParalisacaoFim}
            />
          </Col>
          <Col xs={12} sm={6} md={2}>
            <DatePicker
              id="dataReinicioInicio"
              name="dataReinicioInicio"
              label="Data Reinício Mínima"
              onChange={handleDateChange}
              value={filtros.dataReinicioInicio}
            />
          </Col>
          <Col xs={12} sm={6} md={2}>
            <DatePicker
              id="dataReinicioFim"
              name="dataReinicioFim"
              label="Data Reinício Máxima"
              onChange={handleDateChange}
              value={filtros.dataReinicioFim}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div className="form-group">
              <label className="label">Situação</label>
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '12px',
                  marginTop: '4px'
                }}
              >
                {Object.entries(SITUACAO_INTERVENCAO_OXY).map(
                  ([key, label]) => {
                    const checked = (filtros.situacoes || []).includes(key);
                    const cor = corPorSituacao(key);
                    return (
                      <label
                        key={key}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '6px',
                          cursor: 'pointer',
                          fontSize: '13px'
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={checked}
                          onChange={() => handleSituacaoChange(key)}
                        />
                        <span
                          style={{
                            width: '12px',
                            height: '12px',
                            borderRadius: '50%',
                            background: cor,
                            flexShrink: 0,
                            display: 'inline-block'
                          }}
                        />
                        {label}
                      </label>
                    );
                  }
                )}
              </div>
            </div>
          </Col>
          <Col xs={12} sm={6} md={3}>
            <FilterButtons onConsulta={onConsulta} onReset={onReset} />
          </Col>
        </Row>
      </form>
    </Panel>
  );
};

export default MapaObrasPublicasFilters;
